var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-information-circle-outline",
    "data-name": "Icon ionic-ios-information-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_54",
    "data-name": "\\u30D1\\u30B9 54",
    d: "M16.552,11.564a1,1,0,0,1,1.978,0,1,1,0,0,1-1.978,0Zm.067,1.535h1.834v6.2H16.619Z",
    transform: "translate(-5.666 -3.278)",
    fill: "#4f7dbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_55",
    "data-name": "\\u30D1\\u30B9 55",
    d: "M11.875,4.519a7.353,7.353,0,1,1-5.2,2.154,7.307,7.307,0,0,1,5.2-2.154m0-1.144a8.5,8.5,0,1,0,8.5,8.5,8.5,8.5,0,0,0-8.5-8.5Z",
    fill: "#4477c0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.2ad3c4956aaa83bad56e9074ea64d238.svg";
export { ForwardRef as ReactComponent };